import { Periodicity } from './periodicity';
import { BalanceJournal } from './leave-balance';

export class LeaveType {
  id = '';
  code = '';
  name = '';
  unitsPerDay: number = null;
  unlimited = false;
  days: number = null;
  grantedAfter: number = null;
  expiresAfter: number = null;
  category: 'lossOfPay' | 'OnDuty' | 'paidLeave' | null = null;
  periodicity: Periodicity = new Periodicity();
  journal: BalanceJournal = new BalanceJournal();
  carryForward: number = null;
  monthlyLimit: number;
  openingLeavebalance: number = 0;
  isEdit = false;
  limitedAccess: boolean
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/models/leave-type.ts